import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

export default function AnnualIncomeDialog(props) {
  return (
    <Dialog open={props.open} onClose={props.onAnnualIncomeDialogClosed} scroll="body">
      <DialogContent className="product-info-dialog-content">
        <IconButton
          className="product-info-close-button"
          aria-label="close"
          onClick={props.onAnnualIncomeDialogClosed}
          size="large">
          <CloseIcon />
        </IconButton>

        <h4>Annual Income</h4>
        <p>The minimum annual income supported is $18,000</p>

        <p>Annual income includes salary, bonuses, commissions and other monetary compensation (net of expenses for business owners and self-employed individuals).</p>
      </DialogContent>
    </Dialog>
  );
}

AnnualIncomeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onAnnualIncomeDialogClosed: PropTypes.func.isRequired,
};
